// extracted by mini-css-extract-plugin
module.exports = {"light-animation":"HomeContentTwo_light-animation__3tr1g"};